import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {unregister} from './registerServiceWorker';
import {CookiesProvider} from 'react-cookie';

import {applyMiddleware, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {routerMiddleware} from 'connected-react-router'
import rootReducer from './reducers/rootReducer';
import {createBrowserHistory} from 'history'

import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'

import {fetchUser} from "./actions/userActions";


const history = createBrowserHistory();

const store = createStore(
    rootReducer(history),
    compose(
        applyMiddleware(
            routerMiddleware(history),
            thunk
        ),
    ),
);

if (history.location.pathname !== '/login') {
    store.dispatch(fetchUser());
}

unregister();

ReactDOM.render(
    <CookiesProvider>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App/>
            </ConnectedRouter>
        </Provider>
    </CookiesProvider>, document.getElementById('root')
);

